import { myTasks, type TaskItem } from "@/mocks/managerWorkspace";

function statusBadge(status: string) {
  if (status === "В работе") return "bg-[#FEF3C7] text-[#D97706]";
  if (status === "Новая") return "bg-[#D4EDDA] text-[#2D6A4F]";
  return "bg-[#FEE2E2] text-[#DC2626]";
}

function priorityBadge(priority: string) {
  if (priority === "Высокий") return "bg-[#FEE2E2] text-[#DC2626]";
  if (priority === "Средний") return "bg-[#FEF3C7] text-[#D97706]";
  return "bg-[#D4EDDA] text-[#2D6A4F]";
}

export default function TasksWidget() {
  const visibleTasks = myTasks.slice(0, 6);

  return (
    <div className="bg-white rounded-lg border border-[#D5CA8A] overflow-hidden h-full flex flex-col">
      <div className="flex items-center justify-between px-3 py-2 bg-[#FEF3C7] border-b border-[#D5CA8A]">
        <div className="flex items-center gap-1.5">
          <i className="ri-task-line text-[12px] text-[#2D2D2D]"></i>
          <span className="text-[11px] font-semibold text-[#2D2D2D]">Мои задачи на сегодня</span>
        </div>
        <span className="text-[11px] font-bold text-[#2D2D2D]">{myTasks.length}</span>
      </div>
      <div className="flex-1 overflow-auto">
        <table className="w-full text-[10px]">
          <thead>
            <tr className="bg-[#FDF2B5]/50 text-[#666666]">
              <th className="text-left px-2 py-1 font-medium">Задача</th>
              <th className="text-left px-2 py-1 font-medium">Срок</th>
              <th className="text-left px-2 py-1 font-medium">Приоритет</th>
              <th className="text-left px-2 py-1 font-medium">Клиент</th>
              <th className="text-left px-2 py-1 font-medium">Статус</th>
            </tr>
          </thead>
          <tbody>
            {visibleTasks.map((t: TaskItem, i: number) => (
              <tr key={i} className="border-b border-[#D5CA8A]/30 hover:bg-[#FDF2B5]/30 transition-colors">
                <td className="px-2 py-1.5 text-[#2D2D2D]">{t.title}</td>
                <td className="px-2 py-1.5 text-[#666666]">{t.deadline}</td>
                <td className="px-2 py-1.5">
                  <span className={`px-1.5 py-0.5 rounded text-[9px] font-medium ${priorityBadge(t.priority)}`}>{t.priority}</span>
                </td>
                <td className="px-2 py-1.5 text-[#666666]">{t.client}</td>
                <td className="px-2 py-1.5">
                  <span className={`px-1.5 py-0.5 rounded text-[9px] font-medium ${statusBadge(t.status)}`}>{t.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-3 py-1.5 border-t border-[#D5CA8A]">
        <button className="text-[10px] text-[#2D2D2D] hover:bg-[#FDF2B5] px-2 py-0.5 rounded transition-colors cursor-pointer">
          Все задачи
        </button>
      </div>
    </div>
  );
}